// Function to handle intersection changes
// function handleIntersection(entries, observer) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             entry.target.classList.add('show'); // Add 'show' class when section is in viewport
//         } else {
//             entry.target.classList.remove('show'); // Remove 'show' class when section is out of viewport
//         }
//     });
// }

// // Initialize Intersection Observer
// const observer = new IntersectionObserver(handleIntersection, {
//     root: null, // Use the viewport as the root
//     threshold: 0.5 // Trigger when 50% of the section is visible
// });

// // Observe the section
// const section = document.querySelector('#w-svg');
// console.log("section", section);
// if (section) {
//     observer.observe(section);
// }

// Wave Function
window.addEventListener("scroll", function () {
    waveOnScroll('.wave', 'animating', $(window).scrollTop());
});

function waveOnScroll(elem, classToAdd, distanceFromTop) {
    $(elem).each(function () {
        var winH = window.innerHeight,
            ElemH = $(this).outerHeight(),
            distTop = $(this).offset().top,
            distBottom = distTop + ElemH,
            scrollDistance = distanceFromTop,
            speedFactor = 1.5; // Adjust this value to increase the speed

        if (distTop <= scrollDistance + winH && distBottom >= scrollDistance) {
            if (!$(this).hasClass(classToAdd)) {
                $(this).addClass(classToAdd);
            }
            $(this).css("background-position-x", 1 * (distTop - scrollDistance) * speedFactor);
        } else {
            $(this).removeClass(classToAdd);
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const arrows = document.querySelectorAll('.bounce-arrow .pi-button--arrow');
  
    function checkVisibility() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  
      arrows.forEach(arrow => {
        const rect = arrow.getBoundingClientRect();
        const isVisible = rect.top <= viewportHeight * 0.8 && rect.bottom >= 0;
  
        if (isVisible) {
          if (!arrow.classList.contains('bounce')) {
            // Trigger the bounce animation
            // arrow.style.opacity = 1;
            arrow.classList.add('bounce');
          }
        } else {
          // Reset state if not visible
        //   arrow.style.opacity = 0;
          arrow.classList.remove('bounce');
        }
      });
    }
  
    // Check visibility on scroll
    window.addEventListener('scroll', checkVisibility);
  
    // Check visibility on initial load
    checkVisibility();
  });
  